import {
  Box,
  Typography,
  TextField,
  Button,
  FormControlLabel,
  Checkbox,
  Divider,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

export default function PaymentSection({ onNext, onBack }) {
  return (
    <Box>
      <Typography variant="h5" gutterBottom>
        Payment
      </Typography>
      <Typography variant="body2" color="text.secondary" mb={2}>
        Accept payment or skip for now.
      </Typography>

      <Box sx={{ display: "grid", gap: 2, maxWidth: 400 }}>
        <TextField label="Total Amount" type="number" fullWidth />
        <TextField label="Payment Method" select fullWidth SelectProps={{ native: true }}>
          <option>Cash</option>
          <option>Card</option>
          <option>Online</option>
        </TextField>
        <FormControlLabel control={<Checkbox />} label="Skip payment for now" />
      </Box>

      <Divider sx={{ my: 3 }} />

      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Button variant="outlined" startIcon={<ArrowBackIcon />} onClick={onBack}>
          Back
        </Button>
        <Button variant="contained" onClick={() => onNext({ payment: true })}>
          Continue to Review
        </Button>
      </Box>
    </Box>
  );
}
